// Use public URLs for large cover and hero WEBPs so they are served as static files
export const barcelonaStar = '/covers/barcelona_star.webp';
export const blueTracktor = '/covers/blue_tracktor_boys.webp';
export const blueTracktorBoys = '/covers/blue_tracktor_boys.webp';
export const blueTracktorGirls = '/covers/blue_tractor_girls.webp';
export const dinasor = '/covers/dinasor_boys.webp';
export const dinasorBoys = '/covers/dinasor_boys.webp';
export const dinasorGirls = '/covers/dinasor_girls.webp';
export const elzasKingdom = '/covers/elzas_kingdom.webp';
export const fcAstana = '/covers/fc_astana.webp';
export const fcKairat = '/covers/fc_kairat.webp';
export const footballStar = '/covers/football_star.webp';
export const garryPotter = '/covers/garry_potter_girls.webp';
export const garryPotterBoys = '/covers/garry_potter_boys.webp';
export const garryPotterGirls = '/covers/garry_potter_girls.webp';
export const hantix = '/covers/hantix.webp';
export const hokkeyChampionWay = '/covers/hokkey_champion_way.webp';
export const kazakhBatyr = '/covers/kazakh_batyr.webp';
export const kuromi = '/covers/kuromi.webp';
export const ladyBug = '/covers/lady_bug.webp';
export const mashaBearBoys = '/covers/masha_bear_boys.webp';
export const mashaBearGirls = '/covers/masha_bear_girls.webp';
export const pawPatrol = '/covers/paw_patrol.webp';
export const princesses = '/covers/princesses.webp';
export const raceMcqueen = '/covers/race_mcqueen.webp';
export const real = '/covers/real.webp';
export const rusalochka = '/covers/rusalochka.webp';
export const snich = '/covers/snich_boys.webp';
export const snichBoys = '/covers/snich_boys.webp';
export const snichGirls = '/covers/snich_girls.webp';
export const sonicX = '/covers/sonic_x_boys.webp';
export const sonicXBoys = '/covers/sonic_x_boys.webp';
export const sonicXGirls = '/covers/sonic_x_girls.webp';
export const spiderman = '/covers/spiderman.webp';
export const strange = '/covers/strange_boys.webp';
export const strangeBoys = '/covers/strange_boys.webp';
export const strangeGirls = '/covers/strange_girls.webp';
export const threeCat = '/covers/three_cat_girls.webp';
export const threeCatBoys = '/covers/three_cat_boys.webp';
export const threeCatGirls = '/covers/three_cat_girls.webp';
export const zveropolis = '/covers/zveropolis_girls.webp';
export const zveropolis_boys = '/covers/zveropolis_boys.webp';
export const zveropolitsGirls = '/covers/zveropolis_girls.webp';
export const heroImage = '/covers/hero_image.webp';
export const poster = '/covers/poster.webp';
export const puzzle = '/covers/puzzle.webp';
export const elsa = '/covers/elsa.webp';